import React from "react";
import { FaShip, FaGasPump, FaTachometerAlt, FaRuler, FaCheckCircle, FaTimesCircle } from "react-icons/fa";

function WaterTransportDetails({ product }) {
    if (!product) return <p className="productspec-error">Məhsul detalları yüklənmir...</p>;

    const getStatus = (val, yes = "Bəli", no = "Xeyr") =>
        val === true ? yes : val === false ? no : "Bilinmir";

    const specs = [
        { label: "Ad", value: product.name, icon: <FaShip /> },
        { label: "Qiymət", value: product.price ? `${product.price} AZN` : null },
        { label: "Şəhər", value: product.cityName },
        { label: "Kateqoriya", value: product.categoryName },
        { label: "Alt Kateqoriya", value: product.subCategoryName },
        { label: "Marka", value: product.brandName },
        { label: "Model", value: product.modelName },
        { label: "İstehsal ili", value: product.year },
        { label: "Yanacaq növü", value: product.fuelTypeName, icon: <FaGasPump /> },
        { label: "At gücü", value: product.horsePower ? `${product.horsePower} HP` : null },
        { label: "Uzunluq", value: product.length ? `${product.length} m` : null, icon: <FaRuler /> },
        { label: "Sürət", value: product.speed ? `${product.speed} km/saat` : null, icon: <FaTachometerAlt /> },
        { label: "İstifadə məqsədi", value: product.usagePurpose },
        { label: "Nəqliyyat növü", value: product.transportType },
        { label: "Rəng", value: product.color },
        { label: "Oturacaq sayı", value: product.seatCount },
        { label: "Mühərrik tipi", value: product.engineType },
        { label: "Mühərrik həcmi", value: product.engineVolume ? `${product.engineVolume} L` : null },
        { label: "Material", value: product.material },
        { label: "Yeni?", value: getStatus(product.isNew), status: product.isNew },
        { label: "Qəzalı olub?", value: getStatus(product.isAccidented), status: product.isAccidented === false },
        { label: "VIN", value: product.vin },
        { label: "Bazar tipi", value: product.marketCountry },
        { label: "İstifadə bölgəsi", value: product.usageRegion }
    ];

    return (
        <div className="productspec-container productspec-container--automotive">
            <div className="productspec-header">
                <FaShip className="productspec-header__icon" />
                <h3 className="productspec-header__title">Su Nəqliyyatı Məlumatları</h3>
            </div>

            <div className="productspec-grid">
                {specs.map((spec, index) => {
                    if (!spec.value || spec.value === "Bilinmir") return null;
                    
                    return (
                        <div key={index} className="productspec-item">
                            {spec.icon && <span className="productspec-item__icon">{spec.icon}</span>}
                            <div className="productspec-item__content">
                                <span className="productspec-item__label">{spec.label}</span>
                                <span className={`productspec-item__value ${spec.status !== undefined ? (spec.status ? 'productspec-item__value--success' : 'productspec-item__value--danger') : ''}`}>
                                    {spec.status !== undefined && (
                                        spec.status ? <FaCheckCircle className="productspec-status-icon productspec-status-icon--success" /> : <FaTimesCircle className="productspec-status-icon productspec-status-icon--danger" />
                                    )}
                                    {spec.value}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>

            {product.description && (
                <div className="productspec-description">
                    <h4 className="productspec-description__title">Əlavə Təsvir</h4>
                    <p className="productspec-description__text">{product.description}</p>
                </div>
            )}
        </div>
    );
}

export default WaterTransportDetails;